export const en = {
    "copyright": "© {year} Yandex LLC",
    "copyrightYango": "© {year} Yango",
    "doc": "Documentation",
    "feedback": "Feedback",
    "service-is-provided-by-Yango": "The service is provided by Yango company for ",
    "service-is-provided-by-Yandex": "The service is provided by Yandex company for "
} as const;
export const ru = {
    "copyright": "© {year} ООО «Яндекс»",
    "copyrightYango": "© {year} Yango",
    "doc": "Документация",
    "feedback": "Обратная связь",
    "service-is-provided-by-Yango": "Услуга предоставляется партнерской компанией Yango для следующих стран: ",
    "service-is-provided-by-Yandex": "Услуга предоставляется партнерской компанией Yandex для следующих стран: "
} as const;
